import Vue from 'vue'
import axios from '@/http-common'

import { DOCUMENTOS_REQUEST, DOCUMENTOS_ERROR, DOCUMENTOS_SUCCESS } from '../actions/documentos'
import { CARPETAS_REQUEST, CARPETAS_ERROR, CARPETAS_SUCCESS } from '../actions/documentos'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { 
  status: '', 
  carpetas: [],
  documentos: []
}

const getters = {
}

const actions = {
  [CARPETAS_REQUEST]: ({commit}, payload) => {
    commit(CARPETAS_REQUEST)
    axios.get('/documentos/carpetas?idcomunidad=' + payload.idComunidad , {})
      .then(response => {
        commit(CARPETAS_SUCCESS, response.data)
      })
      .catch(() => {
        commit(CARPETAS_ERROR)
      })
  },
  [DOCUMENTOS_REQUEST]: ({commit}, payload) => {
    commit(DOCUMENTOS_REQUEST)
    axios.get('/documentos?idcomunidad=' + payload.idComunidad + '&carpeta=' + payload.carpeta , {})
      .then(response => {
        commit(DOCUMENTOS_SUCCESS, response.data)
      })
      .catch(() => {
        commit(DOCUMENTOS_ERROR)
      })
  }
}

const mutations = {
  [CARPETAS_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [CARPETAS_SUCCESS]: (state, resp) => {
    state.status = 'success'
    
    Vue.set(state, 'carpetas', resp)
  },
  [CARPETAS_ERROR]: (state) => {
    state.status = 'error'
  },
  [DOCUMENTOS_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [DOCUMENTOS_SUCCESS]: (state, resp) => {
    state.status = 'success'
    
    Vue.set(state, 'documentos', resp)
  },
  [DOCUMENTOS_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.documentos = []
    state.carpetas = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
